import React, { createContext, useEffect, useState } from "react";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import themeConfig from '../../theme'; // Import your main theme

export const ColorModeContext = createContext({
  colorMode: "",
  setColorMode: () => {}
});

const lightTheme = createTheme({
  ...themeConfig, // Spread your theme config
  palette: {
    ...themeConfig.palette, // Spread existing palette
    mode: 'light', // Set the mode
     background: { // You might want a different background for dark mode
      ...themeConfig.palette.background, // Or inherit from base theme
      default: '#F5F3F6', // Example dark mode background override if needed
     }
  },
});

// 다크테마 제거 - 항상 라이트모드만 사용


export const ColorModeContextProvider = ({ children }) => {

  // 항상 라이트모드로 고정
  const [colorMode, setColorMode] = useState("light");

  useEffect(() => {
    window.localStorage.setItem("colorMode", "light");
  }, []);

  const changeColorMode = () => {
    // 다크모드 전환을 무시하고 항상 라이트모드 유지
    console.log('Color mode change ignored - always light mode');
  };

  return (
    <ColorModeContext.Provider
      value={{
        setColorMode: changeColorMode,
        colorMode,
      }}
    >
      <ThemeProvider
        theme={lightTheme} // 항상 라이트 테마 사용
      >
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};
